
import { motion } from "framer-motion";
import { BadgeAlert, X } from "lucide-react";
import moment from "moment";

const ConflictWarningModal = ({
  newActionTitle,
  conflicts,
  onConfirmOverride,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-background/80 backdrop-blur-md p-4 transition-all duration-300">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="relative w-full max-w-md bg-surface/90 backdrop-blur-xl border border-amber-500/30 rounded-3xl shadow-2xl shadow-amber-900/20 p-8"
      >
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors bg-white/5 hover:bg-white/10 rounded-full p-2"
        >
          <X size={20} />
        </button>

        <div className="text-center">
          <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-amber-500/20 animate-pulse-slow">
             <BadgeAlert className="h-8 w-8 text-amber-500" />
          </div>
          <h2 className="text-2xl font-black tracking-tighter text-white">
            Time Conflict Detected
          </h2>
          <p className="mt-2 text-sm text-gray-400">
            Your plan to <span className="text-white font-medium">"{newActionTitle}"</span> overlaps with the following item(s):
          </p>
        </div>

        <div className="mt-6 max-h-40 overflow-y-auto space-y-2 rounded-xl bg-black/40 border border-white/5 p-3 custom-scrollbar">
          {conflicts.map((item, index) => (
            <div key={index} className="text-left p-3 bg-white/5 rounded-lg border border-white/5">
              <p className="font-semibold text-amber-200 text-sm">{item.title}</p>
              <p className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500/50" />
                {moment(item.start_time).format("h:mm A")} -{" "}
                {moment(item.end_time).format("h:mm A")}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-6 text-sm text-center text-gray-400">
          Are you sure you want to proceed and create this item anyway?
        </p>

        <div className="mt-6 flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 bg-white/5 text-white font-bold py-3 rounded-xl hover:bg-white/10 border border-white/10 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirmOverride}
            className="flex-1 bg-amber-500 text-black font-bold py-3 rounded-xl hover:bg-amber-400 transition-colors shadow-lg shadow-amber-500/20"
          >
            Proceed Anyway
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default ConflictWarningModal;
